"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckboxValue = void 0;
var getCheckboxValue = function (obj, path) {
    var nestedValues = obj;
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var p = path_1[_i];
        if (!nestedValues[p]) {
            return false;
        }
        if (nestedValues[p] === true) {
            return true;
        }
        nestedValues = nestedValues[p];
    }
    return nestedValues === true;
};
exports.getCheckboxValue = getCheckboxValue;
//# sourceMappingURL=getCheckboxValue.js.map